import { sendApiClientRequest } from "../../api/api";

const BASE = "/api/teaching-files";

const unwrap = (res) => {
  if (!res || res.status >= 400) {
    const msg = res?.data?.msg ?? "請求失敗";
    throw new Error(typeof msg === "string" ? msg : JSON.stringify(msg));
  }

  const body = res.data;
  if (!body || typeof body !== "object") {
    return null;
  }
  if (body.error) {
    const msg = body.msg ?? "錯誤";
    throw new Error(typeof msg === "string" ? msg : JSON.stringify(msg));
  }
  return body.data !== undefined ? body.data : null;
};

export const fetchAiLearningResourcesList = async ({
  search = "",
  page = 1,
  limit = 15,
  display,
} = {}) => {
  const params = new URLSearchParams();

  if (typeof search === "string" && search.trim()) {
    params.set("search", search.trim());
  }

  params.set("page", String(page));
  params.set("limit", String(limit));
  if (typeof display === "boolean") {
    params.set("display", display ? "1" : "0");
  }

  const res = await sendApiClientRequest("GET", `${BASE}?${params.toString()}`);
  return unwrap(res);
};

export const fetchAiLearningResourceById = async (id) => {
  const res = await sendApiClientRequest("GET", `${BASE}/${id}`);
  return unwrap(res);
};

export const createAiLearningResource = async (payload) => {
  const res = await sendApiClientRequest("POST", BASE, payload);
  return unwrap(res);
};

export const createAiLearningResourceMultipart = async (formData) => {
  const res = await sendApiClientRequest("POST", BASE, formData, true);
  return unwrap(res);
};

export const updateAiLearningResource = async (id, payload) => {
  const res = await sendApiClientRequest("PATCH", `${BASE}/${id}`, payload);
  return unwrap(res);
};

export const updateAiLearningResourceMultipart = async (id, formData) => {
  const res = await sendApiClientRequest("POST", `${BASE}/${id}`, formData, true);
  return unwrap(res);
};

export const deleteAiLearningResource = async (id) => {
  const res = await sendApiClientRequest("DELETE", `${BASE}/${id}`);
  return unwrap(res);
};

export const patchAiLearningResourceDisplay = async (id, display) => {
  const res = await sendApiClientRequest("PATCH", `${BASE}/${id}/display`, {
    display,
  });
  return unwrap(res);
};

export const fetchAiLearningResourceDownloads = async (
  id,
  { from, to } = {},
) => {
  const params = new URLSearchParams();
  if (typeof from === "string" && from.trim()) {
    params.set("from", from.trim());
  }
  if (typeof to === "string" && to.trim()) {
    params.set("to", to.trim());
  }

  const queryString = params.toString();
  const endpoint = queryString
    ? `${BASE}/${id}/downloads?${queryString}`
    : `${BASE}/${id}/downloads`;

  const res = await sendApiClientRequest("GET", endpoint);
  return unwrap(res);
};
